import React from 'react';
import PropTypes from 'prop-types';

export const DynamicComponentRender = ({
  config: {
    type,
    id,
    ...restConfigs
  },
  componentsMapping,
}) => {
  const ItemComponent = componentsMapping[type];

  if (!ItemComponent) {
    return null;
  }

  return (
    <div data-component-type={type} data-component-id={id}>
      <ItemComponent id={id} {...restConfigs} />
    </div>
  );
};

DynamicComponentRender.propTypes = {
  config: PropTypes.shape({
    type: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  componentsMapping: PropTypes.objectOf(PropTypes.elementType).isRequired,
};
